export const GET_TRADE_LIST = 'trade_list/GET_TRADE_LIST'
export const START_LOADING_TRADE_LIST = 'trade_list/START_LOADING_TRADE_LIST'
export const STOP_LOADING_TRADE_LIST = 'trade_list/STOP_LOADING_TRADE_LIST'
